export default __webpack_public_path__ + "video/ART2.mp4";